import React from 'react';
import { useTable } from 'react-table'
import "../table.css"

function AccessionsTable() {
  const columns = React.useMemo(
   () => [
     {
       Header: 'ID',
       accessor: 'id', // accessor is the "key" in the data
     },
     {
       Header: 'Name',
       accessor: 'name',
     },
     {
       Header: 'Alias',
       accessor: 'alias',
     },
     {
       Header: 'Stock ID',
       accessor: 'stock_id',
     },
     {
       Header: 'Sequenced by',
       accessor: 'sequenced_by',
     },
     {
       Header: 'Country',
       accessor: 'country',
     },
     {
       Header: 'Publication',
       accessor: 'publication',
     },
     {
       Header: 'Actions',
       accessor: 'jbrowse_link',
       Cell: props => <a href={props.value}>JBrowse</a>
     },
     {
       Header: '',
       accessor: 'map_link',
       Cell: props => <a href={props.value}>Show on Map</a>
     },
     {
       Header: '',
       accessor: 'sra_link',
       Cell: props => <a href={props.value}>SRA</a>
     },
     {
       Header: '',
       accessor: 'stock_center_link',
       Cell: props => <a href={props.value}>Stock Center</a>
     },
     {
       Header: '',
       accessor: 'data_center_link',
       Cell: props => <a href={props.value}>Data Download</a>
     },
   ],
   []
 )

 const data = React.useMemo(
   () => [
     {
         "id": 1741,
         "name": "KBS-Mac-74",
         "alias": "",
         "stock_id": "CS78969",
         "sequenced_by": "MPI",
         "country": "USA",
         "latitude": 42.405,
         "longitude": -85.398,
         "collector": "Diane Byers",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6024,
         "name": "Fly2-2",
         "alias": "",
         "stock_id": "CS76864",
         "sequenced_by": "GMI",
         "country": "SWE",
         "latitude": 55.7509,
         "longitude": 13.3712,
         "collector": "Magnus Nordborg",
         "publication": "Jaegle_2021_BioRxiv",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6069,
         "name": "Nyl-7",
         "alias": "",
         "stock_id": "CS77137",
         "sequenced_by": "GMI",
         "country": "SWE",
         "latitude": 62.9513,
         "longitude": 18.2763,
         "collector": "Magnus Nordborg",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6124,
         "name": "T690",
         "alias": "",
         "stock_id": "CS77309",
         "sequenced_by": "GMI",
         "country": "SWE",
         "latitude": 55.8378,
         "longitude": 13.3092,
         "collector": "Mattias Jakobsson",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6244,
         "name": "TRÄ 01",
         "alias": "",
         "stock_id": "CS77384",
         "sequenced_by": "GMI",
         "country": "SWE",
         "latitude": 62.9169,
         "longitude": 18.4728,
         "collector": "Mattias Jakobsson",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6909,
         "name": "Col-0",
         "alias": "",
         "stock_id": "CS76778",
         "sequenced_by": "MPI",
         "country": "USA",
         "latitude": 38.3,
         "longitude": -92.3,
         "collector": "Albert Kranz",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 6966,
         "name": "Sq-1",
         "alias": "",
         "stock_id": "CS77266",
         "sequenced_by": "GMI",
         "country": "UK",
         "latitude": 51.4083,
         "longitude": -0.6383,
         "collector": "Mick Crawley",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 8236,
         "name": "HSm",
         "alias": "",
         "stock_id": "CS76941",
         "sequenced_by": "GMI",
         "country": "CZE",
         "latitude": 49.33,
         "longitude": 15.76,
         "collector": "Jirina Relichov",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9075,
         "name": "Lerik1-4",
         "alias": "",
         "stock_id": "CS77023",
         "sequenced_by": "GMI",
         "country": "AZE",
         "latitude": 38.7406,
         "longitude": 48.6131,
         "collector": "James Beck",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9537,
         "name": "IP-Cum-1",
         "alias": "",
         "stock_id": "CS76787",
         "sequenced_by": "MPI",
         "country": "ESP",
         "latitude": 38.07,
         "longitude": -6.66,
         "collector": "Carlos Alonso-Blanco",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9543,
         "name": "IP-Gra-0",
         "alias": "",
         "stock_id": "CS76886",
         "sequenced_by": "GMI",
         "country": "ESP",
         "latitude": 36.77,
         "longitude": -5.39,
         "collector": "Xavier Picó",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9638,
         "name": "Noveg-3",
         "alias": "",
         "stock_id": "CS77133",
         "sequenced_by": "GMI",
         "country": "RUS",
         "latitude": 51.73,
         "longitude": 80.86,
         "collector": "",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9728,
         "name": "Stiav-1",
         "alias": "",
         "stock_id": "CS77279",
         "sequenced_by": "GMI",
         "country": "SVK",
         "latitude": 48.46,
         "longitude": 18.9,
         "collector": "",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9764,
         "name": "Qar-8a",
         "alias": "",
         "stock_id": "CS76581",
         "sequenced_by": "MPI",
         "country": "LBN",
         "latitude": 34.1,
         "longitude": 35.84,
         "collector": "",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9888,
         "name": "IP-Pva-1",
         "alias": "",
         "stock_id": "CS77197",
         "sequenced_by": "GMI",
         "country": "ESP",
         "latitude": 40.93,
         "longitude": -3.31,
         "collector": "Xavier Picó",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9905,
         "name": "Ven-0",
         "alias": "",
         "stock_id": "CS78840",
         "sequenced_by": "GMI",
         "country": "ESP",
         "latitude": 40.76,
         "longitude": -4.01,
         "collector": "Carlos Alonso-Blanco",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 9981,
         "name": "Angit-1",
         "alias": "",
         "stock_id": "CS76366",
         "sequenced_by": "MPI",
         "country": "ITA",
         "latitude": 38.76,
         "longitude": 16.24,
         "collector": "",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 10002,
         "name": "TueWal-2",
         "alias": "",
         "stock_id": "CS76405",
         "sequenced_by": "MPI",
         "country": "GER",
         "latitude": 48.53,
         "longitude": 9.04,
         "collector": "Kirsten Bomblies",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 10015,
         "name": "Sha",
         "alias": "",
         "stock_id": "CS929",
         "sequenced_by": "MPI",
         "country": "TJK",
         "latitude": 38.35,
         "longitude": 68.48,
         "collector": "",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 10024,
         "name": "Tnz-1",
         "alias": "",
         "stock_id": "CS77369",
         "sequenced_by": "MPI",
         "country": "TZA",
         "latitude": -2.87389,
         "longitude": 36.2128,
         "collector": "Maarten Koornneef",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22001,
         "name": "85-3",
         "alias": "",
         "stock_id": "",
         "sequenced_by": "CAS",
         "country": "CHN",
         "latitude": 32.14,
         "longitude": 115.06,
         "collector": "Ya-Long Guo",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22002,
         "name": "35-1",
         "alias": "",
         "stock_id": "",
         "sequenced_by": "CAS",
         "country": "CHN",
         "latitude": 27.94,
         "longitude": 108.61,
         "collector": "Ya-Long Guo",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22003,
         "name": "Taz-0",
         "alias": "",
         "stock_id": "CS799913",
         "sequenced_by": "MPI",
         "country": "",
         "latitude": 34.09166,
         "longitude": -4.10258,
         "collector": "Carlos Alonso-Blanco",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22004,
         "name": "Elh-2",
         "alias": "",
         "stock_id": "CS799925",
         "sequenced_by": "MPI",
         "country": "",
         "latitude": 31.47197,
         "longitude": -7.40644,
         "collector": "Carlos Alonso-Blanco",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22005,
         "name": "Rabacal-1",
         "alias": "R1",
         "stock_id": "CS2107642",
         "sequenced_by": "MPI",
         "country": "POR",
         "latitude": 32.7536,
         "longitude": -17.1297,
         "collector": "Maarten Koornneef",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22006,
         "name": "Areeiro-1",
         "alias": "A1, Are-1",
         "stock_id": "635AV",
         "sequenced_by": "MPI",
         "country": "POR",
         "latitude": 32.74,
         "longitude": -16.93,
         "collector": "Fabrice Roux",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       },
       {
         "id": 22007,
         "name": "ET-86.4",
         "alias": "",
         "stock_id": "",
         "sequenced_by": "MPI",
         "country": "ETH",
         "latitude": 13.235084,
         "longitude": 38.061701,
         "collector": "Pádraic Flood",
         "publication": "",
         "map_link": "",
         "jbrowse_link": "",
         "sra_link": "",
         "stock_center_link": "",
         "data_center_link": ""
       }
   ],
   []
 )

 

 const {
   getTableProps,
   getTableBodyProps,
   headerGroups,
   rows,
   prepareRow,
 } = useTable({ columns, data })

 return (
   <table {...getTableProps()} style={{ border: 'solid 1px blue' }}>
     <thead>
       {headerGroups.map(headerGroup => (
         <tr {...headerGroup.getHeaderGroupProps()}>
           {headerGroup.headers.map(column => (
             <th
               {...column.getHeaderProps()}
               style={{
                 borderBottom: 'solid 3px red',
                 background: 'aliceblue',
                 color: 'black',
                 fontWeight: 'bold',
               }}
             >
               {column.render('Header')}
             </th>
           ))}
         </tr>
       ))}
     </thead>
     <tbody {...getTableBodyProps()}>
       {rows.map(row => {
         prepareRow(row)
         return (
           <tr {...row.getRowProps()}>
             {row.cells.map(cell => {
               return (
                 <td
                   {...cell.getCellProps()}
                   style={{
                     padding: '10px',
                     border: 'solid 1px gray',
                     background: 'papayawhip',
                   }}
                 >
                   {cell.render('Cell')}
                 </td>
               )
             })}
           </tr>
         )
       })}
     </tbody>
   </table>
 )
}

export default AccessionsTable;
